<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Containers</b>
    </sui-card-content>
    <sui-card-content>
      <sui-table definition unstackable compact="very" basic="very">
        <sui-table-body>
          <sui-table-row>
            <sui-table-cell collapsing text-align="center">{{containersByStatus.ONLINE.length}}</sui-table-cell>
            <sui-table-cell>Online</sui-table-cell>
          </sui-table-row>
          <sui-table-row>
            <sui-table-cell collapsing text-align="center">{{containersByStatus.OFFLINE.length}}</sui-table-cell>
            <sui-table-cell>Offline</sui-table-cell>
          </sui-table-row>
          <sui-table-row>
            <sui-table-cell collapsing text-align="center">{{containersByStatus.RESTARTING.length}}</sui-table-cell>
            <sui-table-cell>Restarting</sui-table-cell>
          </sui-table-row>
        </sui-table-body>
      </sui-table>
    </sui-card-content>
    <sui-button-group class="fluid" size="mini" attached="bottom">
      <sui-button :disabled="isScaleDisabled" @click.prevent="$modals.scaleService.open(service)" data-goal="SERVICE_PAGE_CONTAINERS_SCALE_SERVICE">Scale</sui-button>
      <sui-dropdown ref="dropdown" class="icon" button icon="ellipsis vertical">
        <sui-dropdown-menu>
          <sui-dropdown-item icon="green scale balance" :disabled="isBalanceDisabled" data-goal="SERVICE_PAGE_CONTAINERS_BALANCE_SERVICE" @click.prevent="createBalancer()">Load balancing</sui-dropdown-item>
          <sui-dropdown-item icon="orange directions" :disabled="isLogProviderDisabled" data-goal="SERVICE_PAGE_CONTAINERS_OPEN_LOGPROVIDER" @click.prevent="openLogProviderSelector()">Log redirection</sui-dropdown-item>
          <sui-dropdown-item icon="terminal" :disabled="isExecuteDisabled" data-goal="SERVICE_PAGE_CONTAINERS_EXECUTE_SERVICE" @click.prevent="$modals.executeCommands.open(service)">Execute command</sui-dropdown-item>
        </sui-dropdown-menu>
      </sui-dropdown>
    </sui-button-group>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'
  import objects from '@/objects'

  export default {
    name: 'ServiceContainersCard',
    props: {
      service: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['access', 'actionsById', 'containersByService']),
      actions() {
        return this.actionsById[this.service.id]
      },
      containersByStatus() {
        const containers = this.containersByService[this.service.id]
        const containersByStatus = {ONLINE: [], OFFLINE: [], RESTARTING: []}
        for (const container of containers) {
          const key = container.status in containersByStatus ? container.status : 'OFFLINE'
          containersByStatus[key].push(container)
        }
        return containersByStatus
      },
      inProgress() {
        return this.service._inProgress
      },
      isScaleDisabled() {
        return !this.service.constructor.methods.scale || this.service._isOffline || this.inProgress || !this.actions.serviceScale
      },
      isBalanceDisabled() {
        const hasUnsupportedProtocols = this.service.ports.some(port => !objects.ServiceHAProxy.fields.services.servicePortProtocols.includes(port.protocol))
        const hasMethod = this.service.constructor.methods.balance
        const hasAccess = this.access.serviceCreate
        return hasUnsupportedProtocols || !hasMethod || !hasAccess
      },
      isLogProviderDisabled() {
        return !this.actions.serviceUpdate
      },
      isExecuteDisabled() {
        return !this.service.constructor.methods.execute || !this.service._isDeployed || this.inProgress || !this.actions.serviceTerminal
      },
    },
    methods: {
      createBalancer() {
        const haproxy = objects.Service.create({type: 'haproxy'})
        const mode = haproxy.getServiceConfigMode(this.service)
        haproxy.project = this.service.project
        haproxy.name = `${this.service.name}-lb`
        haproxy.services = [haproxy.getServiceConfig(this.service)]
        if (mode === 'tcp') {
          haproxy.ports = this.service.ports.filter(port => port.protocol === 'TCP')
        }
        this.$modals.createService.open(haproxy)
      },
      openLogProviderSelector() {
        const service = this.service._clone
        service.upsert = service.updateLogProvider
        this.$modals.updateService.open(service, 'updatingLogProvider')
      },
    },
  }
</script>

<style scoped>
  .content.content:nth-child(2) { padding: 0!important; overflow: hidden; justify-content: flex-start; }
  .table { margin: 0!important; height: 100%; }
  .center { padding: .4em 1em!important; }
  .aside { position: absolute; top: 7%; right: 0; z-index: 1; display: flex; flex-direction: column; align-items: flex-end; }
  .aside .button { flex-shrink: 1; padding: .3em!important; white-space: nowrap; transform: translate(100%)!important; margin-right: 2.1em!important; font-size: .8em!important; transition: all .3s!important; }
  .aside .button:hover { transform: translate(0)!important; margin-right: 0!important; }
</style>
